module.exports = __webpack_public_path__ + "img/p2-37.04b37fe5.png";